// extracted by mini-css-extract-plugin
export default {"statutory-component":"StatutoryComponent_statutory-component__zUSNS"};